import { useState } from 'react';

export const usePaginationData = (posts: any[], postsPerPage: number = 12) => {
  const [ currentPage, setCurrentPage ] = useState(1);

  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentPosts = posts.slice(firstPostIndex, lastPostIndex);
  const pagesQuantity = Math.ceil(posts.length / postsPerPage);

  return {
    setCurrentPage,
    pagesQuantity,
    currentPosts,
  };
};